import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { formatValue } from '@ts-core/utils/dataTableUtils';

import Table from '@ts-core/components/Table';

const MediaItemStatsTable = (props) => {
  const intl = useIntl();

  const {
    onFetchStats,
    onFilterStats,
    onClickStudent,
    onGetXlsxData,
    mediaStats,
    loading,
    error,
  } = props;
  const { totalViews, students = [], media } = mediaStats;

  const columns = useMemo(
    () => [
      {
        Header: intl.formatMessage({ id: 'field.name.label' }),
        accessor: 'name',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'field.email.label' }),
        accessor: 'email',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'assignmentResultsTable.group' }),
        value: intl.formatMessage({ id: 'assignmentResultsTable.group' }),
        accessor: 'group.name',
        id: 'group.name',
        sortable: true,
        filterable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.totalViews' }),
        accessor: 'totalViews',
        Footer: totalViews ? `${totalViews}` : '-',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.avgProgress' }),
        accessor: 'avgProgressPercentage',
        valueTransformer: (value) => formatValue(value, 1),
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.maxProgress' }),
        accessor: 'maxProgressPercentage',
        valueTransformer: (value) => formatValue(value, 1),
        sortable: true,
      },
    ],
    [intl, totalViews]
  );

  return (
    <Table
      title={intl.formatMessage({ id: 'mediaItemStatsTable.title' })}
      data={students}
      columns={columns}
      loading={loading}
      errorMessage={error}
      onRefreshData={onFetchStats}
      onSearch={onFilterStats}
      onSelectRow={onClickStudent}
      allowDownloadAsXLSX
      xlsxFileName={`${media?.name} - ${intl.formatMessage({
        id: 'mediaItemStatsTable.title',
      })}`}
      getDataToExport={onGetXlsxData}
    />
  );
};

MediaItemStatsTable.propTypes = {
  onFetchStats: PropTypes.func,
  onFilterStats: PropTypes.func,
  onClickStudent: PropTypes.func,
  onGetXlsxData: PropTypes.func,

  mediaStats: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

MediaItemStatsTable.defaultProps = {
  mediaStats: {},
  loading: false,
  error: undefined,
  onFetchStats: undefined,
  onFilterStats: undefined,
  onClickStudent: undefined,
  onGetXlsxData: undefined,
};

export default MediaItemStatsTable;
